import { render, staticRenderFns } from "./PortalDoc.vue?vue&type=template&id=71dc3da0&scoped=true"
import script from "./PortalDoc.vue?vue&type=script&lang=js"
export * from "./PortalDoc.vue?vue&type=script&lang=js"
import style0 from "./PortalDoc.vue?vue&type=style&index=0&id=71dc3da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc3da0",
  null
  
)

export default component.exports